
class RNFS {

}

export default new RNFS();
